







































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { UtilitiesFunctions } from "@/helpers";

@Component
export default class GenericCard extends Vue {
  @Prop({ default: null }) private id!: string;
  @Prop({ default: false }) private homePageCard!: boolean; //Hack for layout refactor - remove after experience detail page ref
  @Prop({ default: null }) private avatar!: string;
  @Prop({ default: "" }) private cardType!: string;
  @Prop({ default: null }) private cardLink!: string;
  @Prop({ default: "" }) private cellarName!: string;
  @Prop({ default: "" }) private description!: string;
  @Prop({ default: null }) private experienceTags!: string;
  @Prop({ default: null }) private activityTags!: string;
  @Prop({ default: null }) private missionTags!: string;
  @Prop({ default: "" }) private imageUrl!: string;
  @Prop({ default: "265" }) private imageHeight!: string;
  @Prop({ default: null }) private address!: string;
  @Prop({ default: null }) private price!: string;
  @Prop({ default: null }) private priceSymbol!: string;
  @Prop({ default: null }) private priceType!: string;
  @Prop({ default: "" }) private title!: string;
  @Prop({ default: false}) private instantBooking!: boolean

  // get imageUrlProductCard() {
  //   return UtilitiesFunctions.imageUrlStringManager(
  //     "c_fill,h_200",
  //     this.imageUrl
  //   );
  // }

  goToLink(linkUrl: string, id: string) {
    const toRoute = UtilitiesFunctions.handleRoute(linkUrl);
    const ref = this.$route.query.ref as string;
    const tap_test = this.$route.query.tap_test as string;
    if (this.cardType === "experienceCard" || this.cardType === 'cellarCard') {
      let path = `${toRoute}/${id}`;
      let routeData = this.$router.resolve({
        path,
        query: { ref, tap_test } }
      );
      window.open(routeData.href, "_blank");
    } else {
      this.$router.push({ path: `${toRoute}/${id}` });
    }
  }
  openDetailPopup(id: string) {
    // console.log(id);
    this.$store
      .dispatch("app/setDialog", {
        type: "productDetail",
        state: true,
        childData: id
      })
      .then(() => {})
      .catch(error => {
        console.error(error);
      });
  }
}
